const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Wybierz",
  seeAll: "Zobacz wszystko",
  clear: "Wyczyść",
  back: "Wróć",
  save: "Zapisz",
  close: "Zamknij",
  of: "z",
  to: "do",
  copyrights: "© {date} Bridgestone Solutions. Wszelkie prawa zastrzeżone.",
  pageNotFound: "Strona nie znaleziona",
  accessDenied: "Dostęp zabroniony",
  search: "Szukaj",
  year: "Rok",
  buttons: {
    loading: "Ładowanie...",
    export: "Eksportuj",
    delete: "Usunąć",
    save: "Zapisz",
    cancel: "Anuluj",
    next: "Dalej",
    back: "Wróć",
    clear: "Wyczyść",
    skip: "Pomiń",
    send: "Zapisz",
    close: "Zamknij",
    readNow: "Czytaj więcej",
    pointsList: "Lista punktów",
    more: "Więcej",
    reportError: "Zgłoś błąd",
    accept: "Akceptuj",
    download: "Pobierz",
    downloadAll: "Pobierz wszystko",
    selectAll: "Zaznacz wszystko",
    deselectAll: "Odznacz wszystko",
    downloadSelection: "Pobierz zaznaczone",
    dealerInfoDownload: "Pobierz",
    toTheBasket: "Koszyk",
    toOrderDelivery: "Adres dostawy",
    discover: "Sprawdź",
    newAddress: "Nowy adres dostawy",
    selectAddressBtn: "Wybierz adres dostawy",
    toOrderSummary: "Podusmowanie",
    placeOrder: "Złóz zamówienie",
    toDashboard: "Strona gówna",
    newOrder: "Nowe zamówienie",
    userOrders: "Do Twoich zamówień",
    toSearch: "Szukaj",
    select: "Wybierz",
    moreCustomerNumbers: "+ DODAJ WIĘCEJ NUMERÓW KLIENTA",
    loadMore: "Załaduj więcej",
    toStaffDashboard: "Do panelu",
    toQuiz: "Do quizu",
    vouchers: "Vouchery",
    exchangeVoucher: "Zrealizuj kod vouchera",
    confirm: "Potwierdź",
    sharePoints: "Udostępnij punkty",
    create: "Stwórz",
    update: "Aktualizuj",
    toBDrive: "Do B-Drive",
    preview: "Podgląd",
    clickHere: "Zobacz szczegóły",
    setFilters: "Ustaw <b>maksymalnie jeden filtr na kolumnę</b>",
    all: "Wszystkie",
  },
  tooltips: {
    info: "Potrzebujesz pomocy? +48 22 393 3791",
  },
  confirmation: {
    header: "Wymagane potwierdzenie",
    message: "Czy chcesz usunąć ten wpis?",
  },
  nav: {
    consents: "Zgody",
    dashboard: "Panel",
    accountDashboard: "Panel",
    account: "Mój Profil",
    mailbox: "Skrzynka odbiorcza",
    singleMailbox: "Wiadomości",
    stammdaten: "Dane główne",
    news_feeds: "Aktualności",
    pointsOverview: "Saldo punktów",
    rewardsOverview: "Saldo punktów",
    about: "O BS Plus",
    service_number: "Kontakt z serwisem",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> sklep",
    salesPromotions: "Promocja sprzedazy",
    promotions: "Moje konto",
    shopCategory: "Sklep",
    productDetails: "Szczegóły porduktu",
    userOrders: "Zamówienia",
    shoppingCart: "Koszyk",
    orderDelivery: "Ades dostawy",
    orderSummary: "Podgląd zamówienia",
    orderComplete: "Zamówienie zakończone",
    text_page: "Strona statyczna",
    staff: "Panel serwisowy",
    onlineTrainings: "Szkolenia online",
    training: "Szkolenie",
    trainingForm: "Formularz szkolenia",
    staffVouchers: "Vouchery",
    wholesalerVouchers: "Vouchery",
    brochure_prices: "Cenniki i broszury",
    investment: "Wsparcie inwestycyjne",
    media: "Media",
    medias: "Media",
    contact_service: "Informacje kontaktowe i serwis",
    productInfo: "INFORMACJE O PRODUKCIE",
    bDrive: "Zdjęcia produktów",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Warunki uczestnictwa",
    first_stop: "Gwarancja na opony Bridgestone",
    payouts: "Payouts",
    bonusUhrd: "Bonus UHRD",
    bonusGoals: "Cele zakupowe",
    bonusAwans: "BONUS ZA AWANS",
    portalPromotions: "Promocje",
    portalPromotionDetail: "Szczegóły promocji",
  },
  breadcrumbs: {
    dashboard: "Panel",
    accountDashboard: "Panel",
    account: "Mój Profil",
    mailbox: "Skrzynka odbiorcza",
    singleMailbox: "Wiadomości",
    stammdaten: "Dane główne",
    news_feeds: "Aktualności",
    pointsOverview: "Saldo punktów",
    rewardsOverview: "Saldo punktów",
    about: "O BS Plus",
    service_number: "Kontakt z serwisem",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> sklep",
    salesPromotions: "Promocja sprzedazy",
    promotions: "Moje konto",
    shopCategory: "Sklep",
    productDetails: "Szczegóły porduktu",
    userOrders: "Zamówienia",
    shoppingCart: "Koszyk",
    orderDelivery: "Ades dostawy",
    orderSummary: "Podgląd zamówienia",
    orderComplete: "Zamówienie zakończone",
    staff: "Panel serwisowy",
    onlineTrainings: "Szkolenia online",
    training: "Szkolenie",
    trainingForm: "Formularz szkolenia",
    staffVouchers: "Vouchery",
    wholesalerVouchers: "Vouchery",
    brochure_prices: "Cenniki i broszury",
    investment: "Wsparcie inwestycyjne",
    media: "Media",
    medias: "Media",
    contact_service: "Informacje kontaktowe i serwis",
    productInfo: "INFORMACJE O PRODUKCIE",
    bDrive: "Zdjęcia produktów",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Warunki uczestnictwa",
    first_stop: "Gwarancja na opony Bridgestone",
    payouts: "Payouts",
    portalPromotions: "Promocje",
    portalPromotionDetail: "Szczegóły promocji",
  },
  menu: {
    account: "Mój Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Wsparcie sprzedaży",
    mailbox: "Skrzynka odbiorcza",
    about: "O BS Plus",
    trainingAndCourses: "Szkolenia i kursy",
    externalTraining: "Szkolenia zewnętrzne",
    productInfo: "Informacje o produktach",
    productBrochures: "Broszury produktowe",
    priceLists: "Cenniki",
    price: "Cena",
    complaintForm: "Formularz reklamacyjny",
    sales_support: "Wsparcie sprzedaży",
    contact_service: "Informacje kontaktowe i serwis",
    logOut: "Wyloguj się",
    news: "Aktualności",
    news_feeds: "Aktualności",
    service_number: "Kontakt",
    salesPromotions: "Promocja sprzedazy",
    shop: "Sklep",
    onlineTrainings: "Szkolenia Online",
    trainings: "Szkolenia",
    brochure_prices: "Cenniki i broszury",
    media: "Media",
    medias: "Media",
    stammdaten: "Dane główne",
    preislisten: "Cenniki",
  },
  validation: {
    requiredField: "Pole wymagane",
  },
  sortBy: {
    default: "Sortuj według",
    desc: "Sortuj według: Najnowsze",
    asc: "Sortuj według: Najstarsze",
    name: "Nazwa",
    date: "Data",
    choiceBy: "Sortuj",
  },
  month: {
    1: "styczeń",
    2: "luty",
    3: "marzec",
    4: "kwiecień",
    5: "maj",
    6: "czerwiec",
    7: "lipiec",
    8: "sierpień",
    9: "wrzesień",
    10: "październik",
    11: "listopad",
    12: "grudzień"
  },
};


export default {
  messages,
};
